/* eslint-disable */

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UserSettingsRouteImport } from './routes/user-settings'
import { Route as MySpeakersRouteImport } from './routes/my-speakers'
import { Route as MyProgramRouteImport } from './routes/my-program'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'

const UserSettingsRoute = UserSettingsRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => rootRouteImport,
})
const MySpeakersRoute = MySpeakersRouteImport.update({
  id: '/my-speakers',
  path: '/my-speakers',
  getParentRoute: () => rootRouteImport,
})
const MyProgramRoute = MyProgramRouteImport.update({
  id: '/my-program',
  path: '/my-program',
  getParentRoute: () => rootRouteImport,
})
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
})
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
})
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
})
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
})
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
})

const rootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  MyProgramRoute: MyProgramRoute,
  MySpeakersRoute: MySpeakersRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ContactRoute: ContactRoute,
  UserSettingsRoute: UserSettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)